import React from 'react';
import { Navigate } from 'react-router-dom';

function NotAuthenticatedGuardRoute({ children }) {
  const isAuthenticated = !!localStorage.getItem('cms_token');

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default NotAuthenticatedGuardRoute;
